import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Value from './common/Value';
import { getLiftgateReasonDetail } from '../DriverPopUp/common/liftgateUtils';
import { DELIVERY_ACCESSORIALS, PICKUP_ACCESSORIALS } from '../constants';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  value: {
    marginRight: 16
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 8
  },
  accessorialValueContainer: {
    marginLeft: 0,
    marginRight: 8,
    padding: 8,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText
  }
});

const AccessorialValue = withStyles(styles)(({ value, classes }) => {
  return value ? <div className={classes.accessorialValueContainer}>{value}</div> : null;
});

export const getSortAndSegregateDisplayValue = (labelText, sortAndSegregatePieces) => {
  const sortAndSegregateValue = Number(sortAndSegregatePieces);
  return sortAndSegregateValue > 0 ? `${labelText} (${sortAndSegregateValue})` : null;
};

const Accessorial = ({
  classes,
  selectedAccessorials,
  selectedLimitedAccessCode,
  selectedLiftgateReasonCode,
  sortAndSegregatePieces,
  accessorialList,
  limitedAccessList,
  liftgateReasonList = [],
  DispatchStore,
}) => {
  const getLimitedAccessLabel = () => {
    const limitedAccessDetails = limitedAccessList.find(
      (limitedAccess) => limitedAccess.value === selectedLimitedAccessCode
    );
    return limitedAccessDetails ? limitedAccessDetails.label : null;
  };

  const getLiftgateReasonLabel = () =>
    getLiftgateReasonDetail(liftgateReasonList, selectedLiftgateReasonCode);

  const isLimitedAccess = (name) =>
    name === DELIVERY_ACCESSORIALS.LIMITED_ACCESS || name === PICKUP_ACCESSORIALS.LIMITED_ACCESS;
  const isLiftgate = (name) =>
    name === DELIVERY_ACCESSORIALS.LIFTGATE || name === PICKUP_ACCESSORIALS.LIFTGATE;
  const isSortAndSegregate = (name) =>
    name === DELIVERY_ACCESSORIALS.SORT_AND_SEGREGATE || name === PICKUP_ACCESSORIALS.SORT_AND_SEGREGATE;

  const getAccessorialDisplayValue = (matchedAccessorial) => {
    if (isLimitedAccess(matchedAccessorial.name)) {
      const label = getLimitedAccessLabel();
      return label ? `${matchedAccessorial.labelText} (${label})` : matchedAccessorial.labelText;
    }
    if (isLiftgate(matchedAccessorial.name)) {
      const reasonLabel = getLiftgateReasonLabel();
      return reasonLabel ? `${matchedAccessorial.labelText} (${reasonLabel})` : matchedAccessorial.labelText;
    }
    if (isSortAndSegregate(matchedAccessorial.name)) {
      return (
        getSortAndSegregateDisplayValue(matchedAccessorial.labelText, sortAndSegregatePieces) ?? matchedAccessorial.labelText
      );
    }
    return matchedAccessorial.labelText;
  };
  return (
    <div className={classes.container}>
      <Label labelText="Accessorial" />
      <div className={classes.valueContainer}>
        {selectedAccessorials?.length > 0 && accessorialList?.length > 0 ? (
          <>
            {selectedAccessorials.map((accessorial) => {
              const matchedAccessorial = accessorialList.find((a) => a.name === accessorial);
              if (matchedAccessorial) {
                return (
                  <AccessorialValue
                    key={accessorial}
                    value={getAccessorialDisplayValue(matchedAccessorial)}
                  />
                );
              }
              return null;
            })}
          </>
        ) : (
          <Value value="NA" />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Accessorial);
